(function () {
  'use strict';

const WAW_CONFIG = {
    phone: "551142101132",
    brandName: "Woolie",
    pillTitle: "Descubra o produto ideal",
    welcomeMessage: "Oi! 👋 Quer ajuda pra escolher o produto certo pro seu gato? Precisa de ajuda com seu pedido?",
    typewriterQuestions: [
      "Qual produto é ideal pro meu gato?",
      "Quero saber sobre brinquedos interativos",
      "Tem desconto na primeira compra?",
      "Preciso de ajuda com meu pedido"
    ],
    faqs: [
      "Me ajuda a escolher um brinquedo pro meu gato",
      "Tem desconto na primeira compra?",
      "Quero saber mais sobre a areia Duna",
      "Preciso de ajuda com meu pedido"
    ],
    typeSpeed: 60, eraseSpeed: 30, pauseAfterTyping: 1800, pauseAfterErasing: 400
  };

  const pill = document.getElementById('wawPill');
  const popup = document.getElementById('wawPopup');
  if (!pill || !popup || pill.dataset.wawReady) return;
  pill.dataset.wawReady = 'true';

  const typedSpan = document.getElementById('wawTyped');
  const input = document.getElementById('wawInput');
  const DISMISS_KEY = 'waw_dismissed_pages';
  function dismissedPages() {
    try { return new Set(JSON.parse(sessionStorage.getItem(DISMISS_KEY) || '[]')); }
    catch (_) { return new Set(); }
  }
  if (dismissedPages().has(window.location.pathname)) {
    pill.classList.add('waw-hidden');
    popup.classList.add('waw-hidden');
    return;
  }

  document.getElementById('wawPillTitle').textContent = WAW_CONFIG.pillTitle;
  document.getElementById('wawHeaderTitle').textContent = 'WhatsApp da ' + WAW_CONFIG.brandName;
  document.getElementById('wawWelcome').textContent = WAW_CONFIG.welcomeMessage;

  // These components already expose their state; there is no viewport hit-testing.
  const STICKY_TARGETS = '.p-stickybar, .wb-sticky, #ClubeSticky, .sticky-variant-bar';
  const STICKY_OPEN = '.p-stickybar.show, .wb-sticky.is-on, #ClubeSticky.is-on, .sticky-variant-bar.show:not(.hide)';
  const CSS_STICKY_TARGETS = '#wl-cf .cf-foot, .quick-order-list__total';
  const COOKIE_TARGETS = '.popup-cookie, #cookie-banner, .cookie-banner, .cookie-consent, #onetrust-banner-sdk, .cky-consent-container';
  const DIALOG_TARGETS = [
    'cart-drawer', '.cart-drawer', '.drawer--cart', '.drawer', 'modal-dialog',
    'product-modal', 'quick-add-modal', 'pickup-availability-drawer', 'dialog',
    '[role="dialog"]', '[aria-modal="true"]', '#Pp2MeasureModal', '.wl-popup',
    'header-drawer > details', 'menu-drawer > details', 'details-modal > details'
  ].join(',');
  const OPEN_TARGETS = [
    'cart-drawer.active', 'cart-drawer[open]', '.cart-drawer.active', '.cart-drawer.is-open',
    '.drawer--cart.active', '.drawer.is-open', '.drawer[aria-hidden="false"]',
    'modal-dialog[open]', 'product-modal[open]', 'quick-add-modal[open]',
    'pickup-availability-drawer[open]', 'dialog[open]', '.wl-popup.visible',
    'header-drawer > details[open]', 'menu-drawer > details[open]', 'details-modal > details[open]'
  ].join(',');
  const TARGETS = [STICKY_TARGETS, CSS_STICKY_TARGETS, COOKIE_TARGETS, DIALOG_TARGETS].join(',');
  const ATTRIBUTES = ['class', 'style', 'open', 'hidden', 'aria-hidden', 'aria-modal', 'role'];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const listeners = new AbortController();
  const signal = listeners.signal;
  const targets = new Set();
  const observedStateNodes = new Set();
  let dismissed = false;
  let suspended = true;
  let chatOpen = false;
  let suppressed = false;
  let frameId = null;
  let typeTimer = null;
  let focusTimer = null;
  let registryChanged = false;
  let bottomObserver = null;
  let bottomNeedsRefresh = false;
  let qIndex = 0;
  let charIndex = 0;
  let erasing = false;

  function isOwnNode(node) {
    return node === pill || node === popup || pill.contains(node) || popup.contains(node);
  }
  function canType() {
    return !dismissed && !suspended && !document.hidden && !suppressed && !chatOpen && !reducedMotion.matches;
  }
  function stopTyping() {
    clearTimeout(typeTimer);
    typeTimer = null;
    pill.classList.add('waw-paused');
  }
  function scheduleTyping(delay) {
    if (canType() && typeTimer === null) typeTimer = setTimeout(typeLoop, delay);
  }
  function syncTyping() {
    if (!canType()) {
      stopTyping();
      if (reducedMotion.matches) typedSpan.textContent = WAW_CONFIG.typewriterQuestions[0];
      return;
    }
    pill.classList.remove('waw-paused');
    scheduleTyping(WAW_CONFIG.typeSpeed);
  }
  function typeLoop() {
    typeTimer = null;
    if (!canType()) return;
    const question = WAW_CONFIG.typewriterQuestions[qIndex];
    charIndex += erasing ? -1 : 1;
    typedSpan.textContent = question.slice(0, charIndex);
    let delay = erasing ? WAW_CONFIG.eraseSpeed : WAW_CONFIG.typeSpeed;
    if (charIndex === question.length) {
      erasing = true;
      delay = WAW_CONFIG.pauseAfterTyping;
    } else if (charIndex === 0) {
      erasing = false;
      qIndex = (qIndex + 1) % WAW_CONFIG.typewriterQuestions.length;
      delay = WAW_CONFIG.pauseAfterErasing;
    }
    scheduleTyping(delay);
  }

  function checkSuppress() {
    if (suspended || dismissed || document.hidden) return;
    // Cache styles only for this event's pass. No stale style state between events.
    const styles = new Map();
    function styleOf(el) {
      if (!styles.has(el)) styles.set(el, window.getComputedStyle(el));
      return styles.get(el);
    }
    function visible(el, ignoreOpacity, allowOffscreen) {
      if (!el.isConnected || el.hidden) return false;
      for (let parent = el; parent; parent = parent.parentElement) {
        const style = styleOf(parent);
        if (style.display === 'none' || style.visibility === 'hidden' ||
            (!ignoreOpacity && Number(style.opacity) === 0)) return false;
      }
      const rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && (allowOffscreen ||
        (rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth));
    }
    const bodyStyle = styleOf(document.body);
    const htmlStyle = styleOf(document.documentElement);
    let blocked = bodyStyle.overflow === 'hidden' || htmlStyle.overflow === 'hidden' ||
      bodyStyle.position === 'fixed' || document.body.style.top.startsWith('-') ||
      document.body.matches('.cart-drawer-open, .cart-open');

    if (!blocked) {
      for (const el of targets) {
        if (el.matches(STICKY_TARGETS)) {
          // A show class announces the incoming CTA before its slide-in finishes.
          blocked = el.matches(STICKY_OPEN) && visible(el, true, true);
        } else if (el.matches(CSS_STICKY_TARGETS)) {
          const style = styleOf(el);
          if ((style.position === 'sticky' || style.position === 'fixed') && visible(el)) {
            const rect = el.getBoundingClientRect();
            blocked = rect.bottom >= window.innerHeight - 20 && rect.height < window.innerHeight * 0.6;
          }
        } else if (el.matches(COOKIE_TARGETS)) {
          // Reserve the space during fade-in/out, including the cookie's opening delay.
          blocked = visible(el, true);
        } else if (el.matches(OPEN_TARGETS)) {
          blocked = visible(el, true, true);
        } else if (!el.matches('details, dialog, modal-dialog, product-modal, quick-add-modal')) {
          blocked = visible(el);
        }
        if (blocked) break;
      }
    }
    if (blocked !== suppressed) {
      suppressed = blocked;
      pill.classList.toggle('waw-suppressed', blocked);
      popup.classList.toggle('waw-suppressed', blocked);
    }
    if (blocked) {
      clearTimeout(focusTimer);
      focusTimer = null;
    }
    pill.classList.remove('waw-initializing');
    syncTyping();
  }

  // Attribute changes, resizes and native state events share one pending frame.
  function requestCheck() {
    if (suspended || dismissed || document.hidden || frameId !== null) return;
    frameId = requestAnimationFrame(() => {
      frameId = null;
      if (registryChanged) {
        for (const target of targets) {
          if (!target.isConnected || !target.matches(TARGETS)) targets.delete(target);
        }
        for (const root of document.body.children) {
          if (!isOwnNode(root) && root.matches(TARGETS)) targets.add(root);
        }
        observeTargets();
      }
      if (bottomNeedsRefresh) observeBottomTargets();
      checkSuppress();
    });
  }
  const stateObserver = new MutationObserver(records => {
    for (const record of records) {
      const el = record.target;
      if (!isOwnNode(el) && el.matches(TARGETS) && !targets.has(el)) {
        targets.add(el);
        registryChanged = true;
      } else if (targets.has(el) && !el.matches(TARGETS)) {
        registryChanged = true;
      }
    }
    requestCheck();
  });
  const resizeObserver = new ResizeObserver(requestCheck);

  function observeBottomTargets() {
    bottomNeedsRefresh = false;
    if (bottomObserver) bottomObserver.disconnect();
    bottomObserver = null;
    const stickyTargets = [...targets].filter(el => el.matches(CSS_STICKY_TARGETS));
    if (!stickyTargets.length) return;
    // Pure CSS sticky bars have no show class. Only watch their bottom 20px band.
    bottomObserver = new IntersectionObserver(requestCheck, {
      rootMargin: '-' + Math.max(0, window.innerHeight - 20) + 'px 0px 0px 0px', threshold: 0
    });
    stickyTargets.forEach(el => bottomObserver.observe(el));
  }
  function observeTargets() {
    registryChanged = false;
    stateObserver.disconnect();
    resizeObserver.disconnect();
    observedStateNodes.clear();
    observedStateNodes.add(document.body);
    observedStateNodes.add(document.documentElement);
    // App portals may be inserted into body before receiving role/class attributes.
    for (const root of document.body.children) {
      if (!isOwnNode(root) && !root.matches('script, style, link, template')) observedStateNodes.add(root);
    }
    targets.forEach(el => {
      resizeObserver.observe(el);
      for (let parent = el; parent; parent = parent.parentElement) observedStateNodes.add(parent);
    });
    observedStateNodes.forEach(el => stateObserver.observe(el, { attributes: true, attributeFilter: ATTRIBUTES }));
    observeBottomTargets();
  }
  function discover(node) {
    if (node.nodeType !== 1 || isOwnNode(node)) return false;
    let changed = false;
    function add(el) {
      if (!isOwnNode(el) && !targets.has(el)) {
        targets.add(el);
        changed = true;
      }
    }
    if (node.matches(TARGETS)) add(node);
    node.querySelectorAll(TARGETS).forEach(add);
    return changed;
  }
  function observeStructure() {
    discoveryObserver.disconnect();
    // Watch insertions into content/app containers, excluding the widget entirely.
    // Typing and FAQ updates therefore do not even notify this observer.
    discoveryObserver.observe(document.body, { childList: true });
    for (const root of document.body.children) {
      if (isOwnNode(root) || root.matches('script, style, link, template')) continue;
      discoveryObserver.observe(root, { childList: true, subtree: true });
    }
  }
  const discoveryObserver = new MutationObserver(records => {
    if (suspended || dismissed) return;
    let rootsChanged = false;
    let changed = false;
    for (const record of records) {
      if (isOwnNode(record.target)) continue;
      if (record.target === document.body) rootsChanged = true;
      for (const node of record.addedNodes) if (discover(node)) changed = true;
      for (const node of record.removedNodes) {
        if (node.nodeType === 1 && [...targets].some(target => node === target || node.contains(target))) changed = true;
      }
    }
    if (rootsChanged) observeStructure();
    if (changed || rootsChanged) {
      registryChanged = true;
      requestCheck();
    }
  });

  function pauseWork() {
    suspended = true;
    stopTyping();
    clearTimeout(focusTimer);
    focusTimer = null;
    if (frameId !== null) cancelAnimationFrame(frameId);
    frameId = null;
    stateObserver.disconnect();
    discoveryObserver.disconnect();
    resizeObserver.disconnect();
    if (bottomObserver) bottomObserver.disconnect();
    bottomObserver = null;
    targets.clear();
    observedStateNodes.clear();
  }
  function resumeWork() {
    if (dismissed || document.hidden || !suspended) return;
    suspended = false;
    discover(document.body);
    observeTargets();
    observeStructure();
    checkSuppress();
  }
  function onTargetEvent(event) {
    if (observedStateNodes.has(event.target)) requestCheck();
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) pauseWork(); else resumeWork();
  }, { signal });
  window.addEventListener('pagehide', pauseWork, { signal });
  window.addEventListener('pageshow', resumeWork, { signal });
  window.addEventListener('resize', () => {
    if (suspended || dismissed) return;
    bottomNeedsRefresh = true;
    requestCheck();
  }, { passive: true, signal });
  window.addEventListener('load', requestCheck, { once: true, signal });
  document.addEventListener('toggle', onTargetEvent, { capture: true, signal });
  document.addEventListener('transitionrun', onTargetEvent, { capture: true, signal });
  document.addEventListener('transitionend', onTargetEvent, { capture: true, signal });
  document.addEventListener('animationstart', onTargetEvent, { capture: true, signal });
  document.addEventListener('animationend', onTargetEvent, { capture: true, signal });
  document.body.addEventListener('modalClosed', requestCheck, { signal });
  reducedMotion.addEventListener('change', syncTyping, { signal });

  function openChat() {
    if (dismissed || suspended || suppressed) return;
    chatOpen = true;
    pill.classList.add('waw-hidden');
    popup.classList.remove('waw-hidden');
    syncTyping();
    clearTimeout(focusTimer);
    focusTimer = setTimeout(() => {
      focusTimer = null;
      if (chatOpen && !suppressed && !suspended && !dismissed) input.focus();
    }, 320);
  }
  function closeChat() {
    chatOpen = false;
    clearTimeout(focusTimer);
    focusTimer = null;
    popup.classList.add('waw-hidden');
    pill.classList.remove('waw-hidden');
    syncTyping();
  }
  function dismissWidget(event) {
    event.stopPropagation();
    dismissed = true;
    try {
      const pages = dismissedPages();
      pages.add(window.location.pathname);
      sessionStorage.setItem(DISMISS_KEY, JSON.stringify([...pages]));
    } catch (_) { /* Also stop in memory when sessionStorage is unavailable. */ }
    pill.classList.add('waw-hidden');
    popup.classList.add('waw-hidden');
    pauseWork();
    listeners.abort();
  }
  function sendToWhatsApp(message) {
    const text = message.trim();
    if (text) window.open('https://wa.me/' + WAW_CONFIG.phone + '?text=' + encodeURIComponent(text), '_blank');
  }
  pill.addEventListener('click', openChat, { signal });
  pill.addEventListener('keydown', event => {
    if (event.target === pill && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      openChat();
    }
  }, { signal });
  document.getElementById('wawClose').addEventListener('click', closeChat, { signal });
  document.getElementById('wawDismiss').addEventListener('click', dismissWidget, { signal });
  document.getElementById('wawSend').addEventListener('click', () => sendToWhatsApp(input.value), { signal });
  input.addEventListener('keydown', event => {
    if (event.key === 'Enter') sendToWhatsApp(input.value);
  }, { signal });
  const faqList = document.getElementById('wawFaqList');
  WAW_CONFIG.faqs.forEach(question => {
    const button = document.createElement('button');
    button.className = 'waw-faq-item';
    button.type = 'button';
    const label = document.createElement('span');
    label.textContent = question;
    const arrow = document.createElement('span');
    arrow.className = 'waw-faq-item-arrow';
    arrow.textContent = '›';
    button.append(label, arrow);
    button.addEventListener('click', () => sendToWhatsApp(question), { signal });
    faqList.appendChild(button);
  });
  resumeWork();
})();
